module.exports = __webpack_public_path__ + "media/assets/images/tour/4b_Tour_3-771831254355512257e4ca821057073e.png";